import cx from 'classnames'
import { Icon } from '@vzmi/shp_shared_compo'
import styles from './Information.css'

const Information = ({ className, name, description }) => (
  <div className={cx(styles.information, { [className]: !!className })}>
    <Icon
      name={name || 'ec-information-fill'}
      align='sub'
      color='#c9d0ea'
      size={17}
    />
    {' '}
    {description}
  </div>
)

export default Information
